import { Component, OnInit, Inject } from "@angular/core";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { ModalRef } from "mis-design-system/mis-modal";
import { MODAL_DATA_VAR } from "mis-design-system/mis-modal";

@Component({
  selector: "mis-employee-web-exp-checkout-confirm",
  templateUrl: "./checkout-confirm.component.html",
  styleUrls: ["./checkout-confirm.component.scss"]
})
export class CheckoutConfirmComponent implements OnInit {
  constructor(private _modalRef: ModalRef, @Inject(MODAL_DATA_VAR) data) {}

  assets = CONSTANTS_ASSETS_EMP_WEB_EXP;

  ngOnInit(): void {}

  handleCheckout(value: boolean) {
    this._modalRef.close(value);
  }
}
